import React from 'react';
import Layout from './Layout';
import Portfolio from './Pages/Portfolio';

function App() {
  return (
    <Layout currentPageName="Portfolio">
      <Portfolio />
    </Layout>
  );
}

export default App;